import { FormControl } from 'baseui/form-control'
import { SIZE } from 'baseui/button'

import { HOPInput } from '@/shared/components/HOPComponents/HOPInput'
import HOPSelect from '@/shared/components/HOPComponents/HOPSelect'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDCheckbox from '@/shared/components/SDComponentsNewDesign/SDCheckbox/SDCheckbox'

import useAddEditModal from './useAddEditModal'

interface AddEditModalProps {
  setIsOpen: (open: boolean) => void
  close: () => void
}

interface HOPSelectParams {
  value: { id: string; label: string }[]
}

const AddEditModal = ({ setIsOpen, close }: AddEditModalProps) => {
  const {
    t,
    formErrors,
    selectedTeam,
    updateSelectedTeam,
    submitHandler,
    businessVerticalOptions,
    nameOfBusinessVertical,
  } = useAddEditModal({ setIsOpen })

  const businessVerticalOptionsList = businessVerticalOptions.reduce<Record<string, string>>((acc, option) => {
    acc[option.id] = option.label
    return acc
  }, {})

  return (
    <form onSubmit={submitHandler}>
      <FormControl
        label={t('teamsManagement:modal.business_vertical')}
        error={formErrors.site_id ? formErrors.site_id[0] : ''}
      >
        <HOPSelect
          optionsList={businessVerticalOptionsList}
          placeholder={
            selectedTeam.site_id ? nameOfBusinessVertical(selectedTeam.site_id) : t('common:choose')
          }
          selectedValue={selectedTeam.site_id ? String(selectedTeam.site_id) : ''}
          onChangeHandler={(params: HOPSelectParams) =>
            updateSelectedTeam({ site_id: params.value[0]?.id ?? '' })
          }
        />
      </FormControl>
      <FormControl label={t('teamsManagement:modal.name')} error={formErrors.name ? formErrors.name[0] : ''}>
        <HOPInput
          id='team-name'
          currentValue={selectedTeam.name}
          handleValue={(value: string) => {
            updateSelectedTeam({ name: value })
          }}
        />
      </FormControl>
      {/* @ts-expect-error SDCheckbox is a JS component */}
      <SDCheckbox
        label={t('teamsManagement:modal.can_create_leads_on_own_vertical')}
        checked={selectedTeam.can_create_leads_on_own_vertical}
        onChange={(canCreateLeadsOnOwnVertical: boolean) =>
          updateSelectedTeam({ can_create_leads_on_own_vertical: canCreateLeadsOnOwnVertical })
        }
      />
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton
        disabled={false}
        isLoading={false}
        size={SIZE.compact}
        block={false}
        overrides={{
          BaseButton: {
            style: () => ({
              marginRight: '.5rem',
            }),
          },
        }}
        type='submit'
      >
        {selectedTeam.id ? t('common:edit') : t('common:create')}
      </SDButton>
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton size={SIZE.compact} block={false} type='button' onClick={close}>
        {t('common:cancel')}
      </SDButton>
    </form>
  )
}

export default AddEditModal
